<template functional>
  <component :is="props.tag" :id="data.id" :class="['aspectratio', `ratio-${props.ratio}`, data.class, data.staticClass]" :style="props.enableStyles ? data.style : ''" v-bind="data.attrs">
    <span>
      <slot/>
    </span>
  </component>
</template>

<script>
import SCSS_VARIABLES from '@/assets/js/modules/scss-variables'

const ALLOWED_RATIO_NAMES = SCSS_VARIABLES.vars['ratio-keys']

export default {
  name: 'AspectRatio',
  props: {
    tag: {
      type: String,
      default: 'div'
    },
    ratio: {
      type: String,
      required: true,
      validator: value => ALLOWED_RATIO_NAMES.includes(value)
    },
    enableStyles: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style lang="scss">
.aspectratio {
  display: block;
  position: relative;
  width: 100%;

  &:before {
    display: block;
    content: '';
  }

  @each $key, $value in $aspect-ratios {
    &.ratio-#{$key}:before {
      padding-top: 100% * (1 / $value);
    }
  }

  > span {
    display: flex;
    align-items: center;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
</style>
